import { render, staticRenderFns } from "./ModalSuprimentosAtualizaPrecificacao.vue?vue&type=template&id=a0da9962&scoped=true"
import script from "./ModalSuprimentosAtualizaPrecificacao.vue?vue&type=script&lang=ts"
export * from "./ModalSuprimentosAtualizaPrecificacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalSuprimentosAtualizaPrecificacao.vue?vue&type=style&index=0&id=a0da9962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0da9962",
  null
  
)

export default component.exports